module.exports = __webpack_public_path__ + "static/media/V2_16.37c301a0.png";